import {initElements} from "../define/shared";

export default function initWordAnchors() {
    initElements(".word-anchors.is--anchor", letterPage => {
        const words = letterPage.querySelectorAll(".word");
        const header = document.querySelector('.siteHeader')

        words.forEach(word => {
            word.addEventListener("click", (e) => {
                const desc = document.querySelector(`#${word.dataset.slug}`)

                e.preventDefault();
                words.forEach(item => item.classList.remove("is--active"));
                word.classList.toggle("is--active");

                document.querySelectorAll('.post').forEach(item => item.classList.remove('is--open'))
                desc.classList.add('is--open')

                window.scrollTo({
                    left: 0,
                    top: desc.offsetTop - header.offsetHeight,
                    behavior: "smooth"
                });

                window.history.replaceState(null, null, `#${word.dataset.slug}`);
            });
        });
    });
}
